/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';
import SocialFile from 'entity/SocialFile';
import Paging from 'rest/Paging';
import SocialFileController from 'rest/SocialFileController';

@Injectable({
  providedIn: 'root',
})
export class SocialFileService extends Loggable {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private socialFileController = new SocialFileController();

  public constructor() {
    super();
    this.setDisplayName('SocialFileService');
  }

  public deleteFile(socialRoomSetId: string, socialFileId: string): Promise<void> {
    return this.socialFileController.deleteFile(socialRoomSetId, socialFileId);
  }

  public getFiles(socialRoomSetId: string, page?: Paging): Promise<SocialFile[]> {
    return this.socialFileController.getFiles(socialRoomSetId, page);
  }

  public getDownloadURL(socialRoomSetId: string, socialFileIds: string[]): Promise<string> {
    return this.socialFileController.getDownloadURL(socialRoomSetId, socialFileIds);
  }

  public uploadFile(
    socialRoomSetId: string,
    fileName: string,
    fileType: string,
    fileSize: number,
    fileBytes: any,
  ): Promise<SocialFile> {
    return this.socialFileController.uploadFile(socialRoomSetId, fileName, fileType, fileSize, fileBytes);
  }

  public addCTAItemFiles(CTAItemId: number, socialFileIds: string[]): Promise<void> {
    return this.socialFileController.addCTAItemFiles(CTAItemId, socialFileIds);
  }

  public getCTAItemFiles(CTAItemId: number, page?: Paging): Promise<SocialFile[]> {
    return this.socialFileController.getCTAItemFiles(CTAItemId, page);
  }

  public removeCTAItemFiles(CTAItemId: number, socialFileIds: string[]): Promise<void> {
    return this.socialFileController.removeCTAItemFiles(CTAItemId, socialFileIds);
  }
}
